import {
  AccountRelatedPath,
  getAccountRelatedUrl,
  PaginationQueryParams,
  server,
} from '@/config/urls'
import { composePathAndParams, joinValues } from '@/utils/urls'

export const packageUrls = {
  getViewInstallationPackage: ({
    workspaceId,
    packageId,
  }: AccountRelatedPath & { packageId: string }): string =>
    joinValues(
      getAccountRelatedUrl(workspaceId),
      'packages',
      packageId,
      'install',
      'overview'
    ),
  getWorkspacePackages: ({
    workspaceId,
    params,
  }: AccountRelatedPath & {
    params?: PaginationQueryParams & { status?: string[] }
  }): string => {
    const path = joinValues(getAccountRelatedUrl(workspaceId), 'packages')
    return composePathAndParams(path, params)
  },
  getWorkspacePackagesStore: ({
    workspaceId,
    params,
  }: AccountRelatedPath & { params?: PaginationQueryParams }): string => {
    const path = joinValues(
      getAccountRelatedUrl(workspaceId),
      'packages',
      'store'
    )
    return composePathAndParams(path, params)
  },
  getWorkspacePackageStore: ({
    workspaceId,
    packageId,
  }: AccountRelatedPath & { packageId: string }): string =>
    joinValues(
      getAccountRelatedUrl(workspaceId),
      'packages',
      'store',
      packageId
    ),
  getWorkspacePackagesUpdates: ({
    workspaceId,
    params,
  }: AccountRelatedPath & { params?: PaginationQueryParams }): string => {
    const path = joinValues(
      getAccountRelatedUrl(workspaceId),
      'packages',
      'updates'
    )

    return composePathAndParams(path, params)
  },
  getWorkspacePackageInstall: ({
    packageId,
    workspaceId,
  }: AccountRelatedPath & { packageId: string }): string =>
    joinValues(
      getAccountRelatedUrl(workspaceId),
      'packages',
      packageId,
      'install'
    ),
  getPackagePolicyRule: ({
    workspaceId,
    packageId,
    policyId,
    ruleId,
  }: AccountRelatedPath & {
    packageId: string
    policyId: string
    ruleId: string
  }): string =>
    joinValues(
      getAccountRelatedUrl(workspaceId),
      'packages',
      packageId,
      'policy-entries',
      policyId,
      'rule-entries',
      ruleId
    ),
  getPackagePolicyEntry: ({
    workspaceId,
    packageId,
    policyId,
  }: AccountRelatedPath & {
    packageId: string
    policyId: string
  }): string =>
    joinValues(
      getAccountRelatedUrl(workspaceId),
      'packages',
      packageId,
      'policy-entries',
      policyId
    ),
  getWorkspacePackageDiscard: ({
    packageId,
    workspaceId,
  }: AccountRelatedPath & { packageId: string }): string =>
    joinValues(
      getAccountRelatedUrl(workspaceId),
      'packages',
      packageId,
      'discard'
    ),
  getWorkspacePackagePublish: ({
    packageId,
    workspaceId,
  }: AccountRelatedPath & { packageId: string }): string =>
    joinValues(
      getAccountRelatedUrl(workspaceId),
      'packages',
      packageId,
      'publish'
    ),
  getWorkspacePackage: ({
    packageId,
    workspaceId,
    params,
  }: AccountRelatedPath & {
    packageId: string
    params?: { status?: 'PUBLISHED' | 'DRAFT' }
  }): string => {
    const path = joinValues(
      getAccountRelatedUrl(workspaceId),
      'packages',
      packageId
    )
    return composePathAndParams(path, params)
  },
  getWorkspaceRootPackage: ({ packageId }: { packageId: string }): string =>
    joinValues(server, 'packages', packageId),
  getWorkspaceRootPackages: (): string => joinValues(server, 'packages'),
}
